import React, { useEffect, useState } from 'react';
// import './CheckinNavigator.css';
import { Route, Redirect, RouteComponentProps } from 'react-router-dom';
import { IonLoading, IonRouterOutlet } from '@ionic/react';
import ThankYou from '../pages/appointmentSteps/ThankYou';
import RegisterStep from '../pages/appointmentSteps/RegisterStep';
import { AuthenticationRootState } from '../store/reducers/authentication';
import { connect } from 'react-redux';
import TabBar from '../components/TabBar';
import HasAppointment from '../pages/checkinSteps/HasAppointment';
import AppointmentsSelection from '../pages/checkinSteps/AppointmentsSelection';
import {
  APPOINTMENT_CHECKIN_NEW_APPOINTMENT,
  APPOINTMENT_CHECKIN_NEW_APPOINTMENT_COVID
} from './AppStackNavigator';
import LaboratoryRepository from '../repositories/LaboratoryRepository';
import EventBus from '../services/EventBus';
import { setAppointment } from '../store/actions/appointments';
import { Appointment, Laboratory } from '../models';

const mapStateToProps = (
  state: { authentication: AuthenticationRootState },
  ownProps: any
) => {
  return {
    user: state.authentication.user,
    isLoggedIn: !!state.authentication.accessToken
  };
};

const mapDispatchToProps = (dispatch: Function, ownProps: any) => ({
  selectLaboratory: (appointment: Partial<Appointment>) =>
    dispatch(setAppointment(appointment))
});

export type CheckinNavigatorProps = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps> &
  RouteComponentProps<{ slug: string }> & {
    isCovid: boolean;
  };

const CheckinNavigator: React.FC<CheckinNavigatorProps> = ({
  match,
  isLoggedIn,
  history,
  selectLaboratory
}) => {
  const [laboratories, setLaboratories] = useState<Laboratory[]>([]);
  const [isCovid, setIsCovid] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [checkinMessage, setCheckinMessage] = useState('');

  useEffect(() => {
    async function findLaboratory() {
      const [tmpGroupLaboratories, tmpLaboratory] = await Promise.all([
        LaboratoryRepository.getLaboratoriesByGroupSlug(match.params.slug),
        LaboratoryRepository.findBySlug(match.params.slug)
      ]);

      if (tmpGroupLaboratories?.laboratories.length) {
        setLaboratories(tmpGroupLaboratories.laboratories);
        setCheckinMessage(tmpGroupLaboratories.checkinMessage || '');
      } else if (
        tmpLaboratory &&
        tmpLaboratory.id &&
        tmpLaboratory.appointment_type !== 'none'
      ) {
        setLaboratories([tmpLaboratory]);
        selectLaboratory({ laboratory: tmpLaboratory });
        setIsCovid(tmpLaboratory.covid);
      } else {
        setIsLoading(false);
        EventBus.error('Ce laboratoire semble ne pas exister.');
        history.replace('/');
      }

      setIsLoading(false);
    }

    findLaboratory();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isLoading) {
    return (
      <>
        <IonLoading isOpen={isLoading} />
      </>
    );
  } else {
    return (
      <>
        <IonRouterOutlet animated={true}>
          <Route
            path={`${match.url}`}
            exact
            render={(props) => (
              <HasAppointment
                {...props}
                step={0}
                laboratories={laboratories}
                trueNextStepRouterLink={
                  isLoggedIn
                    ? `${match.url.replace(/\/$/, '')}/rendez-vous`
                    : `${match.url.replace(/\/$/, '')}/connexion`
                }
                checkinMessage={checkinMessage}
                falseNextStepRouterLink={`${
                  isCovid
                    ? APPOINTMENT_CHECKIN_NEW_APPOINTMENT_COVID
                    : APPOINTMENT_CHECKIN_NEW_APPOINTMENT
                }/laboratoire/${match.params.slug}`}
              />
            )}
          />
          <Route
            path={`${match.url}/connexion`}
            render={(props) => (
              <RegisterStep
                {...props}
                step={1}
                nextStepRouterLink={`${match.url.replace(
                  /\/$/,
                  ''
                )}/rendez-vous`}
              />
            )}
          />
          <Route
            path={`${match.url.replace(/\/$/, '')}/rendez-vous`}
            render={(props) => (
              <AppointmentsSelection
                {...props}
                step={2}
                nextStepRouterLink={`${match.url.replace(/\/$/, '')}/merci`}
                laboratories={laboratories}
                newAppointmentRouterLink={`${
                  isCovid
                    ? APPOINTMENT_CHECKIN_NEW_APPOINTMENT_COVID
                    : APPOINTMENT_CHECKIN_NEW_APPOINTMENT
                }/laboratoire/${match.params.slug}`}
              />
            )}
            exact
          />
          <Route
            path={`${match.url.replace(/\/$/, '')}/merci`}
            render={(props) => (
              <ThankYou
                {...props}
                step={3}
                showRatingForm={false}
                bodyText={
                  'Merci de votre coopération.<br/>Bienvenue dans les laboratoires Unilabs.'
                }
              />
            )}
            exact
          />
          <Redirect to={`${match.url}`} />
        </IonRouterOutlet>
        <TabBar history={history} className="ion-custom-hide-md-down" />
      </>
    );
  }
};

export interface CheckingStepProps<T = {}> extends RouteComponentProps<T> {
  step: number;
  nextStepRouterLink?: string;
}

export default connect(mapStateToProps, mapDispatchToProps)(CheckinNavigator);
